module.exports = __webpack_public_path__ + "static/media/ios-clipboard.db2fd514.svg";